
  <template>
  <div
    id="app"
    class="wi-portal"
  >
    <div class="view-wrapper">
      <login-container />
    </div>
  </div>
</template>

<script>
import ApiConfig from 'api/config'
import utils from '@/utils/util'
import loginContainer from '@/pages/login/login.vue'
export default {
  name: 'Login',
  created(){
    if(!utils.isPc()){
      window.location.href = ApiConfig.baseUrl+'/mobile/login'
    }
  },
  components:{
    loginContainer
  }
}
</script>
<style lang="less" scoped>
#app {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  min-width: 1280px;
  .view-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    transition: all 0.3s;
  }
  .view-wrapper.is-browser {
    top: 32px;
  }
}
</style>

<style lang="less" scoped>
.page {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
</style>
<style lang="less">
body,
html {
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0;
}
</style>
